module.exports = __webpack_public_path__ + "media/images/lb/708-47d86f55893e8085164a6fafc25030c5.svg";